export default __webpack_public_path__ + "static/media/mantle_bg154.e3c8f112.jpg";